import React from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { useSelector } from 'react-redux'
import CloseIcon from '../utils/closeIcon'
import useBodyOverflow from '../hooks/useBodyOverflow'

const ModalTier = ({ isOpen, closeModal, modalData }) => {
  useBodyOverflow(isOpen)
  const theme = useSelector((state) =>
    state.mapStyle.darkMode ? 'dark' : 'light'
  )

  return (
    <Transition appear show={isOpen} as={React.Fragment}>
      <Dialog onClose={closeModal}>
        <div className='min-h-screen px-4 text-center'>
          <Dialog.Overlay
            className={`fixed inset-0 opacity-10 ${
              theme === 'dark' ? 'bg-[#353535]' : 'bg-zinc-300'
            } `}
          />
          <span
            className='inline-block h-screen align-middle'
            aria-hidden='true'
          >
            &#8203;
          </span>
          <div
            className={`fixed bottom-24 left-3 inline-block p-6 my-8 mx-10 overflow-hidden text-left align-middle transition-all transform shadow-xl rounded-2xl w-[380px] ${
              theme === 'dark' ? 'bg-[#353535]' : 'bg-white'
            } `}
          >
            <h1
              className={`text-2xl font-bold leading-6 mb-4 text-left ${
                theme === 'dark' ? 'text-zinc-200' : 'text-zinc-700'
              } `}
            >
              Tier Info
            </h1>

            {modalData && (
              <div
                className={`${
                  theme === 'dark' ? 'text-zinc-200' : 'text-zinc-700'
                } `}
              >
                <p>Geohash: {modalData.geohash}</p>
                <p>Type1 Leader: {modalData.type1_leader}</p>
                <p>Type2 Leader: {modalData.type2_leader}</p>
                <p>Type1 Backups: {modalData.type1_backups}</p>
              </div>
            )}

            <button
              type='button'
              className={`absolute top-2 right-2 flex items-center justify-center w-8 h-8 text-white rounded-full hover:bg-blue-600 ${
                theme === 'dark' ? 'bg-zinc-800' : 'bg-zinc-100'
              } `}
              onClick={closeModal}
            >
              <CloseIcon />
            </button>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default ModalTier
